import { useState, useEffect } from "react"
import TCanvas from "@common/canvas/TCanvas"
import Sidebar from "@common/components/Navigation/SideBar"
import PageBuilder from "@common/general/PageBuilder"
import styled from "styled-components/macro"

const SidebarLayout = () => {
  const [hideSidebar, setHideSidebar] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has("hideSidebar")) {
      setHideSidebar(true)
    }
  }, [])

  return (
    <SidebarLayoutWrapper>
      {!hideSidebar && (
        <SidebarLayoutNavWr>
          <Sidebar />
        </SidebarLayoutNavWr>
      )}
      <SidebarLayoutContentWr hideSidebar={hideSidebar}>
        <PageBuilder />
        <TCanvas />
      </SidebarLayoutContentWr>
      <div className="splashAnim"></div>
    </SidebarLayoutWrapper>
  )
}

export default SidebarLayout

const SidebarLayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  .splashAnim {
    opacity: 0;
    pointer-events: none;
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: #0a2620;
  }
`

const SidebarLayoutNavWr = styled.nav`
  position: relative;
  height: 100%;
  width: 15%;
  pointer-events: none;
`

const SidebarLayoutContentWr = styled.main<{ hideSidebar: boolean }>`
  position: relative;
  width: ${({ hideSidebar }) => (hideSidebar ? "100%" : "85%")};
  height: 100%;
  z-index: 3;
  overflow: auto;
`
